import React, { useEffect } from 'react';
import { CONTACT_INFO, LEGAL_INFO, PASS_CODEUR_PRICING } from '@/constants';

const CGV = () => {
  // Scroll automatique en haut de la page au chargement
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen py-12">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-8 text-center">Conditions Générales de Vente</h1>
        
        <div className="space-y-8 text-foreground">
          
          {/* MENTIONS LÉGALES */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">Mentions légales</h2>
            <div className="text-muted-foreground space-y-2">
              <p><strong>Dénomination sociale :</strong> {LEGAL_INFO.COMPANY_NAME}</p>
              <p><strong>Forme juridique :</strong> {LEGAL_INFO.LEGAL_FORM}</p>
              <p><strong>Adresse du siège social :</strong> {LEGAL_INFO.ADDRESS.STREET}, {LEGAL_INFO.ADDRESS.POSTAL_CODE} {LEGAL_INFO.ADDRESS.CITY}, {LEGAL_INFO.ADDRESS.COUNTRY}</p>
              {LEGAL_INFO.CAPITAL !== "[Montant du capital]" && (
                <p><strong>Capital social :</strong> {LEGAL_INFO.CAPITAL}</p>
              )}
              {LEGAL_INFO.SIRET !== "[Numéro SIRET]" && (
                <p><strong>SIRET :</strong> {LEGAL_INFO.SIRET}</p>
              )}
              {LEGAL_INFO.RCS !== "[Numéro RCS]" && (
                <p><strong>RCS :</strong> {LEGAL_INFO.RCS}</p>
              )}
              {LEGAL_INFO.TVA !== "[Numéro TVA intracommunautaire]" && (
                <p><strong>Numéro de TVA intracommunautaire :</strong> {LEGAL_INFO.TVA}</p>
              )}
              <p><strong>Email :</strong> {CONTACT_INFO.EMAIL}</p>
              {LEGAL_INFO.PHONE !== "[Numéro de téléphone]" && (
                <p><strong>Téléphone :</strong> {LEGAL_INFO.PHONE}</p>
              )}
              {LEGAL_INFO.PUBLICATION_DIRECTOR !== "[Nom du directeur de publication]" && (
                <p><strong>Directeur de publication :</strong> {LEGAL_INFO.PUBLICATION_DIRECTOR}</p>
              )}
              
              <div className="mt-4">
                <p><strong>Hébergeur :</strong></p>
                <p>{LEGAL_INFO.HOSTING.PROVIDER}</p>
                <p>{LEGAL_INFO.HOSTING.LEGAL_FORM}</p>
                <p>{LEGAL_INFO.HOSTING.ADDRESS}</p>
                <p><strong>Téléphone :</strong> {LEGAL_INFO.HOSTING.PHONE}</p>
                <p><strong>Email :</strong> {LEGAL_INFO.HOSTING.EMAIL}</p>
                <p><strong>Capital social :</strong> {LEGAL_INFO.HOSTING.CAPITAL}</p>
                <p><strong>SIRET :</strong> {LEGAL_INFO.HOSTING.SIRET}</p>
                <p><strong>RCS :</strong> {LEGAL_INFO.HOSTING.RCS}</p>
                <p><strong>TVA :</strong> {LEGAL_INFO.HOSTING.TVA}</p>
              </div>
            </div>
          </section>

          {/* OBJET */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Objet</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Les présentes conditions générales de vente (ci-après "CGV") régissent exclusivement 
                les relations contractuelles entre {LEGAL_INFO.COMPANY_NAME} (ci-après "le Vendeur") 
                et toute personne physique ou morale souhaitant procéder à un achat via le site internet 
                monpremierjeu.fr (ci-après "l'Acheteur").
              </p>
              <p>
                Le site Mon Premier Jeu propose des services d'apprentissage de la programmation de jeux vidéo 
                sous forme de cours en ligne accessibles via le "Pass Codeur".
              </p>
            </div>
          </section>

          {/* PRODUITS ET SERVICES */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Produits et services</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Le Vendeur propose à la vente le "Pass Codeur" qui donne accès à l'ensemble des cours 
                de programmation de jeux vidéo disponibles sur la plateforme, incluant :
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>Les cours existants au moment de l'achat</li>
                <li>Les nouveaux cours ajoutés ultérieurement</li>
                <li>Les ressources pédagogiques associées</li>
                <li>L'accès aux exercices pratiques et projets</li>
              </ul>
              <p>
                Les cours sont dispensés en langue française et utilisent principalement le langage 
                JavaScript avec la bibliothèque p5.js.
              </p>
            </div>
          </section>

          {/* PRIX ET MODALITÉS DE PAIEMENT */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Prix et modalités de paiement</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                <strong>Prix :</strong> Le Pass Codeur est proposé au prix de {PASS_CODEUR_PRICING.CURRENT_PRICE}€ TTC.
              </p>
              <p>
                Les prix sont exprimés en euros, toutes taxes comprises (TTC), hors frais éventuels 
                de traitement bancaire qui restent à la charge de l'Acheteur.
              </p>
              <p>
                <strong>Modalités de paiement :</strong> Le paiement s'effectue en ligne de manière 
                sécurisée par carte bancaire via la plateforme Stripe. Le débit s'effectue au moment 
                de la validation de la commande.
              </p>
              <p>
                En cas de paiement refusé ou de problème technique, l'Acheteur sera informé et 
                pourra renouveler sa tentative de paiement.
              </p>
            </div>
          </section>

          {/* DROIT DE RÉTRACTATION */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Droit de rétractation</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Conformément aux articles L221-18 et suivants du Code de la consommation, l'Acheteur 
                dispose d'un délai de <strong>14 jours francs</strong> pour exercer son droit de rétractation 
                à compter de la date d'achat, sans avoir à justifier de motifs ni à payer de pénalités.
              </p>
              <p>
                Pour exercer ce droit, l'Acheteur peut :
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>Envoyer un email à {CONTACT_INFO.EMAIL}</li>
                <li>Adresser un courrier recommandé avec accusé de réception à l'adresse mentionnée dans les mentions légales</li>
              </ul>
              <p>
                <strong>Exception :</strong> Conformément à l'article L221-28 du Code de la consommation, 
                le droit de rétractation ne peut être exercé si l'Acheteur a commencé à accéder aux 
                contenus numériques après avoir expressément consenti à la fourniture immédiate du service 
                et renoncé à son droit de rétractation.
              </p>
              <p>
                En cas de rétractation valide, le Vendeur s'engage à rembourser l'intégralité des sommes 
                versées dans un délai de 14 jours à compter de la notification de rétractation.
              </p>
            </div>
          </section>

          {/* LIVRAISON ET ACCÈS AU SERVICE */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Livraison et accès au service</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                L'accès au Pass Codeur est activé immédiatement après confirmation du paiement. 
                L'Acheteur recevra un email de confirmation contenant ses identifiants d'accès.
              </p>
              <p>
                L'accès aux services est fourni pour une durée illimitée, sous réserve du maintien 
                en fonctionnement de la plateforme par le Vendeur.
              </p>
            </div>
          </section>

          {/* PROPRIÉTÉ INTELLECTUELLE */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Propriété intellectuelle</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                L'Acheteur s'engage à utiliser les contenus exclusivement dans le cadre d'un usage 
                personnel et pédagogique. Toute reproduction, distribution, ou utilisation commerciale 
                est strictement interdite sans autorisation écrite préalable.
              </p>
            </div>
          </section>

          {/* PROTECTION DES DONNÉES PERSONNELLES */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Protection des données personnelles (RGPD)</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                <strong>Responsable du traitement :</strong> {LEGAL_INFO.COMPANY_NAME}
              </p>
              <p>
                <strong>Données collectées :</strong> Nom, prénom, adresse email, données de paiement 
                (traitées par Stripe), données de navigation (Google Analytics), cookies de sécurité et prévention de fraude (Stripe).
              </p>
              <p>
                <strong>Finalités :</strong> Gestion des commandes, fourniture du service, communication 
                client, amélioration du service, statistiques de fréquentation.
              </p>
              <p>
                <strong>Base légale :</strong> Exécution du contrat, intérêt légitime du responsable de traitement.
              </p>
              <p>
                <strong>Conservation :</strong> 3 ans après la dernière connexion pour les données de compte, 
                25 mois pour les cookies analytiques.
              </p>
              <p>
                <strong>Droits :</strong> Vous disposez des droits d'accès, de rectification, d'effacement, 
                de limitation, d'opposition et de portabilité de vos données. Contact : {CONTACT_INFO.EMAIL}
              </p>
            </div>
          </section>

          {/* POLITIQUE DES COOKIES */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Politique des cookies</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Ce site utilise des cookies et autres technologies de suivi pour améliorer votre expérience 
                de navigation et analyser l'utilisation du site.
              </p>
              
              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-foreground">Cookies nécessaires</h4>
                  <p className="text-sm">
                    Ces cookies sont indispensables au fonctionnement du site. Ils permettent la navigation, 
                    la gestion de votre session, la sécurité et le traitement des paiements. Ils ne peuvent pas être désactivés.
                  </p>
                  <p className="text-sm mt-2">
                    <strong>Cookies Stripe :</strong> __stripe_mid, __stripe_sid - Utilisés pour traiter les paiements 
                    de manière sécurisée et prévenir la fraude. Durée : Session ou 1 an selon le cookie.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-foreground">Cookies analytiques (Google Analytics)</h4>
                  <p className="text-sm">
                    Ces cookies nous permettent de mesurer l'audience du site, d'analyser la navigation 
                    et d'améliorer nos services. Ils sont déposés uniquement avec votre consentement.
                  </p>
                  <p className="text-sm">
                    <strong>Données collectées :</strong> Pages visitées, durée de visite, provenance 
                    géographique (anonymisée), type d'appareil.
                  </p>
                  <p className="text-sm">
                    <strong>Durée de conservation :</strong> 25 mois maximum.
                  </p>
                </div>
              </div>
              
              <p>
                <strong>Gestion de vos préférences :</strong> Vous pouvez à tout moment modifier vos 
                préférences de cookies en cliquant sur le lien "Paramètres des cookies" en bas de page 
                ou en supprimant les cookies de votre navigateur.
              </p>
              
              <p>
                <strong>Opposition :</strong> Pour vous opposer au suivi par Google Analytics, vous pouvez 
                installer le module complémentaire de navigateur disponible à l'adresse : 
                <a href="https://tools.google.com/dlpage/gaoptout" className="text-blue-600 hover:underline ml-1">
                  https://tools.google.com/dlpage/gaoptout
                </a>
              </p>
            </div>
          </section>

          {/* RESPONSABILITÉ */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Responsabilité et garanties</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Le Vendeur s'engage à fournir un service conforme aux descriptions présentes sur le site 
                et à maintenir la disponibilité de la plateforme dans des conditions normales d'utilisation.
              </p>
              <p>
                La responsabilité du Vendeur ne saurait être engagée en cas de :
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>Interruption temporaire du service pour maintenance</li>
                <li>Problèmes techniques liés au matériel ou à la connexion internet de l'Acheteur</li>
                <li>Utilisation non conforme du service par l'Acheteur</li>
                <li>Force majeure</li>
                <li>Fin du service</li>
              </ul>
              <p>
                En toute hypothèse, la responsabilité du Vendeur est limitée au montant payé par l'Acheteur 
                pour le service concerné.
              </p>
            </div>
          </section>

          {/* RÉSILIATION */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">10. Résiliation</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                En cas de manquement grave de l'Acheteur à ses obligations (notamment utilisation 
                frauduleuse, tentative de piratage, non-respect de la propriété intellectuelle), 
                le Vendeur se réserve le droit de suspendre ou de résilier l'accès au service 
                sans préavis ni remboursement.
              </p>
            </div>
          </section>

          {/* DROIT APPLICABLE */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">11. Droit applicable et juridiction</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Les présentes CGV sont soumises à la loi française. En cas de litige et à défaut 
                de résolution amiable, les tribunaux français seront seuls compétents.
              </p>
            </div>
          </section>

          {/* ENTRÉE EN VIGUEUR */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">12. Entrée en vigueur et modifications</h2>
            <div className="text-muted-foreground space-y-3">
              <p>
                Les présentes CGV entrent en vigueur à la date de leur mise en ligne. 
                Le Vendeur se réserve le droit de les modifier à tout moment. Les modifications 
                s'appliquent aux achats postérieurs à leur mise en ligne.
              </p>
              <p>
                <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
              </p>
            </div>
          </section>

          {/* CONTACT */}
          <section>
            <h2 className="text-2xl font-semibold mb-4">Contact</h2>
            <div className="text-muted-foreground">
              <p>
                Pour toute question concernant ces conditions générales de vente ou pour exercer 
                vos droits, vous pouvez nous contacter :
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
                <li>Par email : {CONTACT_INFO.EMAIL}</li>
                <li>Par courrier : {LEGAL_INFO.COMPANY_NAME}, {LEGAL_INFO.ADDRESS.STREET}, {LEGAL_INFO.ADDRESS.POSTAL_CODE} {LEGAL_INFO.ADDRESS.CITY}, {LEGAL_INFO.ADDRESS.COUNTRY}</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGV;
